export default __webpack_public_path__ + "static/media/PopupIcons_Comments_icon_White.b6173c40.svg";